import { type ReadonlyURLSearchParams } from 'next/navigation';
import type { Dictionary } from '@flemingmetrics/api-client';

export type Params = Dictionary<any>;

export function parseParams(params: ReadonlyURLSearchParams) {
  return Object.fromEntries(params.entries()) as Params;
}

export function stringifyParams(params: Params) {
  return new URLSearchParams(params).toString();
}
